export const BookingIntroTitle = () => {
  return <p>If any payment is due, it will be taken after your appointment.</p>;
};
